import "./newLine.css";

import { useEffect, useState } from 'react'
import Stack from 'react-bootstrap/Stack';
import { hot } from 'react-hot-loader';

import { retrieveMessage as retrieveMessageAPI } from '../../sdk/apis';

const InformationMessage = () => {
  const [messages, setMessages] = useState([]);
  const [nextPath, setNextPath] = useState(null);

  useEffect(() => {
    retrieveMessageAPI(nextPath).then(result => {
      setMessages(prevState => [...prevState, ...result.results]);
      setNextPath(result.next.replace('http://', 'https://') ?? null);
    })
  }, []);

  useEffect(() => {
    if (nextPath) {
      retrieveMessageAPI(nextPath).then(result => {
        setMessages(prevState => [...prevState, ...result.results]);
        setNextPath(result.next.replace('http://', 'https://') ?? null);
      });
    }
  }, [nextPath]);

  if (messages != null) {
    const messageList = messages.map((e, idx) => {
      let formattedDate = null;
      if (e.posted_at) {
        const date = new Date(e.posted_at);
        formattedDate = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
        // } else {
        //   formattedDate = null;
      }
      if (e.display) {
        return (
            <div key={idx} className="container">
              <div className="col p-3 mb-2 bg-success bg-opacity-10 border rounded">
                <b>{formattedDate}   {e.subject}</b>
                <br></br>
                <div className='text'>{e.message}</div>
              </div>
            </div>
        )
      } else {
        return null;
      }
    });

    if (messages) {
      return (
        <>
          <h3 className="col text-black" style={{ paddingLeft: '3em' }}>お知らせ <small><div className="en" style={{paddingTop: '0.3rem'}}>What‘s New</div></small></h3>
          <Stack gap="2">
            {messageList}
          </Stack>
        </>
      );
    } else {
      return (
        <>
          <span className='border rounded'>
            お知らせがありません
          </span>
        </>
      );
    }
  }
  return null;
};

export default hot(module)(InformationMessage);
